import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';

@Component({
    selector: 'app-dashboard-redirect',
    template: '',
    standalone: false
})
export class DashboardRedirectComponent implements OnInit {
 
  constructor(
      private router: Router) 
      { }

  ngOnInit() {
     
        console.log('dashboard ' + localStorage.getItem("clientId"));

        if(localStorage.getItem("clientId").includes('9121')) this.router.navigateByUrl('/mz/dashboard');
     //   if(localStorage.getItem("clientId").includes('9122')) this.router.navigateByUrl('/kmt/dashboard');
        if(localStorage.getItem("clientId").includes('9997')) this.router.navigateByUrl('/monitors/groups/5f629390-69cb-409f-93b4-35506bf0d39a');
    
  }
}